import React, { useRef, useEffect } from 'react';

import st from './index.module.scss';

import Head from 'next/head';

import { MarketingServicesRequestForm, WhatHappensNext } from '../../../components/ksa';
import { AppearencesInMedia, BusinessInNumbers, ReviewsOn } from '../../../components/seo/sections';

const SeoForm = props => {
  const sideBar = useRef(null);
  useEffect(() => {
    document.body.classList.remove('overflow-x-hidden');
    if (sideBar.current) {
      const div = sideBar.current;

      div.style.height = div.scrollHeight + 'px';
    }
  }, []);

  return (
    <>
      <Head>
        <title>Marketing Services Request Form - Get a Proposal | Prodigi</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/services/marketing-services-form" />
        <meta
          name="description"
          content="Fill out Prodigi marketing services form to get a customized plan that aligns with your business needs. Let's take your brand to the next level together."
        />
        <meta property="og:url" content="https://weprodigi.com/services/marketing-services-form" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Marketing Services Request Form - Get a Proposal | Prodigi" />
        <meta
          property="og:description"
          content="Fill out Prodigi marketing services form to get a customized plan that aligns with your business needs. Let's take your brand to the next level together."
        />
      </Head>
      <div className="grid grid-cols-1 md:grid-cols-2">
        <div className="bg-[#F3EEEA] px-[30px] py-[48px]">
          <div className="flex flex-col ml-auto max-w-[520px] gap-[48px]">
            <h1 className="text-[32px] md:text-[34px] font-[600] leading-[42px]">Marketing Services Request Form</h1>
            <div className="w-full flex justify-end">
              <MarketingServicesRequestForm country={props.country} />
            </div>
          </div>
        </div>
        <div className="bg-white md:px-[50px] px-[30px] py-[48px] relative z-[1]">
          <div ref={sideBar} className={`hidden md:flex flex-col absolute ${st['stickyBar']}`}>
            <div className={`flex flex-col max-w-[520px] gap-[48px] items`}>
              <h2 className="flex justify-center text-[34px] font-[600] md:leading-[72px] leading-[41px] text-[#B02A09]">What Happens Next? </h2>
              <div className="grid grid-cols-12 gap-[10px] relative pl-[30px]">
                <img className="absolute top-[9px] left-[-75px]" src="/images/ksa/here.png" alt="here" />

                <div className="col-span-11 py-[10px] px-[25px]">
                  <WhatHappensNext />
                </div>
              </div>
            </div>
          </div>

          <div className={`md:hidden flex flex-col container`}>
            <div className="flex flex-col gap-[48px] items">
              <h2 className="flex justify-center text-[34px] font-[600] md:leading-[72px] leading-[41px] text-[#09AF77]">What Happens Next? </h2>
              <div className="relative ">
                <img className="absolute top-[9px] right-[-40px]" src="/images/ksa/here_mobile.png" alt="here" />

                <div className="py-[10px]">
                  <WhatHappensNext />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ReviewsOn />
      <BusinessInNumbers color="#4DA454" />
      <AppearencesInMedia />
    </>
  );
};

export default SeoForm;
